import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "leftArrow", "rightArrow"];

  connect() {
    this.updateIndicators();
    this.updateIndicatorsBound = this.updateIndicators.bind(this);
    window.addEventListener("resize", this.updateIndicatorsBound);
  }

  disconnect() {
    if (this.updateIndicatorsBound) {
      window.removeEventListener("resize", this.updateIndicatorsBound);
    }
  }

  updateIndicators() {
    if (!this.hasContainerTarget) return;

    const container = this.containerTarget;
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;

    // Tolerance of 1.5px to avoid floating point/rounding issues in high-DPI displays or browser zoom
    const hasLeftOverflow = scrollLeft > 1.5;
    const hasRightOverflow = scrollLeft + clientWidth < scrollWidth - 1.5;

    if (this.hasLeftArrowTarget) {
      if (hasLeftOverflow) {
        this.leftArrowTarget.classList.remove("opacity-0", "pointer-events-none");
        this.leftArrowTarget.classList.add("opacity-100");
      } else {
        this.leftArrowTarget.classList.remove("opacity-100");
        this.leftArrowTarget.classList.add("opacity-0", "pointer-events-none");
      }
    }

    if (this.hasRightArrowTarget) {
      if (hasRightOverflow) {
        this.rightArrowTarget.classList.remove("opacity-0", "pointer-events-none");
        this.rightArrowTarget.classList.add("opacity-100");
      } else {
        this.rightArrowTarget.classList.remove("opacity-100");
        this.rightArrowTarget.classList.add("opacity-0", "pointer-events-none");
      }
    }
  }

  scrollLeft() {
    if (!this.hasContainerTarget) return;
    this.containerTarget.scrollBy({
      left: -150,
      behavior: "smooth"
    });
  }

  scrollRight() {
    if (!this.hasContainerTarget) return;
    this.containerTarget.scrollBy({
      left: 150,
      behavior: "smooth"
    });
  }
}
